import { convertLength } from '@turf/helpers';
import { isNil } from 'lodash-es';

import { AddressItem } from '~hooks/useAddress/models/AddressItem';
import { Nullable } from '~types/Nullable';

// Based on the BE validation of the Address Model, we need to check if any required fields are missing
// If so, the address should be store in the full_address text field
const validateAddress = (address: Nullable<AddressItem>) => {
  if (isNil(address)) return false;

  const requiredFields = [
    'administrativeArea',
    'country',
    'locality',
    'postalCode',
    'thoroughfare',
  ];

  return requiredFields.every((field) => {
    const value = address[field as keyof AddressItem];
    // Check for null/undefined and also trim strings to handle whitespace-only values
    return !isNil(value) && (typeof value !== 'string' || value.trim() !== '');
  });
};

const generatePolygonGeoJson = (drawingCoordinates: { lat: number; lng: number }[]) => {
  if (
    drawingCoordinates.length &&
    (drawingCoordinates[0].lat !==
      drawingCoordinates[drawingCoordinates.length - 1].lat ||
      drawingCoordinates[0].lng !== drawingCoordinates[drawingCoordinates.length - 1].lng)
  ) {
    drawingCoordinates.push(drawingCoordinates[0]);
  }
  return {
    type: 'Polygon',
    coordinates: [
      drawingCoordinates.map((coordinate) => [coordinate.lng, coordinate.lat]),
    ],
  };
};

const generateCircleAttributes = ({
  center,
  radiusInFeet,
}: {
  center: { lat: number; lon: number };
  radiusInFeet: number;
}) => ({
  circle_center: {
    lat: center.lat,
    lon: center.lon,
  },
  circle_radius: convertLength(radiusInFeet, 'feet', 'meters'),
});

export { generateCircleAttributes, generatePolygonGeoJson, validateAddress };
